import { Component, OnInit, HostListener } from '@angular/core';
import { GraphClientService } from './services/graph-client-service';
import { IDiagnosticsService } from './services/interfaces';
import { DiagnosticsServiceFactory } from './services/diagnostics-service-factory';
import { PanelScrollingService } from './modules/dashboard/services/panel-scrolling.service';

const RESOURCEKEY_VALUEWINNERS_TITLE = 'ValuesWinnersTitle';
const RESOURCEKEY_SALESPERFORMERS_TITLE = 'TopSalesPerformersTitle';

/**
 * Root component of the application. Accesses SharePoint Online 'Resources' custom list
 * and pulls high-level dynamic data from there (month-specific headings).
 * It then uses this information as input parameters to its child components, such as
 * ValuesWinnersComponent and TopPerformersComponent.
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  private diagnostics: IDiagnosticsService;
  public isIframe: boolean;
  public valuesWinnersTitle: string;
  public topSalesPerformersTitle: string;
  title = 'app';

  constructor(
    diagnosticsFactory: DiagnosticsServiceFactory,
    private graphClient: GraphClientService,
    private panelScrolling: PanelScrollingService) {
    //  This is to avoid reload during acquireTokenSilent() because of hidden iframe.
    this.isIframe = window !== window.parent && !window.opener;
    this.diagnostics = diagnosticsFactory.create(this.constructor.name);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth > 768) {
      // Go back to first page if our size gets changed.
      this.panelScrolling.moveToPage('none');
    }
  }

  ngOnInit() {
    this.graphClient.getData(this.constructor.name).subscribe(
      data => {
        const dynamicData = data as any;
        const dataItems: Array<any> = dynamicData.value;

        for (let i = 0; i < dataItems.length; ++i) {
          if (dataItems[i].fields.Title === RESOURCEKEY_VALUEWINNERS_TITLE) {
            this.valuesWinnersTitle = dataItems[i].fields.Text;
          } else if (dataItems[i].fields.Title === RESOURCEKEY_SALESPERFORMERS_TITLE) {
            this.topSalesPerformersTitle = dataItems[i].fields.Text;
          } else {
            // Do nothing.
          }
        }
      }, error => {
        this.diagnostics.logError(`Error loading data. Details: ${JSON.stringify(error)}`);
      });
  }
}
